function hydrateLatestWriting() {
    const source = document.querySelector("#cs-latest-writing-source");
    const target = document.querySelector("[data-cs-latest-writing]");

    if (!source || !target) {
        return;
    }

    while (source.firstChild) {
        target.appendChild(source.firstChild);
    }

    source.remove();
}

function groupCards(marker, className, count, selector = ".kg-product-card") {
    const wrapper = document.createElement("div");
    wrapper.className = `cs-card-grid ${className}`;
    marker.before(wrapper);

    let candidate = marker.nextElementSibling;
    let grouped = 0;

    while (candidate && grouped < count) {
        const next = candidate.nextElementSibling;
        if (candidate.matches(selector)) {
            wrapper.appendChild(candidate);
            grouped += 1;
        }
        candidate = next;
    }

    marker.remove();

    if (!grouped) {
        wrapper.remove();
    }
}

function groupEditorialCards() {
    document.querySelectorAll('[data-cs-layout="offer-grid"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--offers", 2);
    });

    document.querySelectorAll('[data-cs-layout="media-grid"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--media", 2);
    });

    document.querySelectorAll('[data-cs-layout="credibility-grid"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--credibility", 3, ".kg-callout-card");
    });

    document.querySelectorAll('[data-cs-layout="about-links"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--triple", 3);
    });

    document.querySelectorAll('[data-cs-layout="elsewhere-grid"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--elsewhere", 2);
    });

    document.querySelectorAll('[data-cs-layout="subject-grid"]').forEach((marker) => {
        groupCards(marker, "cs-card-grid--subjects", 4, ".kg-callout-card");
    });
}

function hydrateHeroSecondaryAction() {
    const marker = document.querySelector('[data-cs-slot="hero-secondary"]');
    const header = marker?.previousElementSibling;
    const buttonCard = marker?.nextElementSibling;
    const headerText = header?.querySelector(".kg-header-card-text");
    const primary = header?.querySelector(".kg-header-card-button");
    const secondary = buttonCard?.matches(".kg-button-card") ? buttonCard.querySelector(".kg-btn") : null;

    if (!marker || !headerText || !secondary) {
        return;
    }

    const actions = document.createElement("div");
    actions.className = "cs-header-actions";
    if (primary) {
        actions.appendChild(primary);
    }
    secondary.classList.add("cs-button", "cs-button--secondary");
    actions.appendChild(secondary);
    headerText.appendChild(actions);
    const noteMarker = buttonCard.nextElementSibling;
    const note = noteMarker?.nextElementSibling;
    if (noteMarker?.matches('[data-cs-slot="hero-note"]') && note?.matches("p")) {
        note.classList.add("cs-hero-note");
        headerText.appendChild(note);
        noteMarker.remove();
    }
    buttonCard.remove();
    marker.remove();
}

/* --- Homepage art direction (presentation only; all wording stays Ghost-owned) --- */

const homeCardLabels = Object.freeze({
    hero: "SINCE 2019 · COLORADO",
    who: "WHO'S ASKING?",
    writing: "READ",
    podcast: "LISTEN",
    newsletter: "THE NEWSLETTER"
});

const homeHeroSecondParagraphStart = "I also write a biweekly newsletter";

function normalizedText(element) {
    return element?.textContent.replace(/\s+/g, " ").trim() ?? "";
}

function withoutLeadingLabel(value, label) {
    const normalized = value.replace(/\s+/g, " ").trim();
    return normalized.startsWith(label)
        ? normalized.slice(label.length).trim()
        : normalized;
}

/* Find the next sibling matching `selector`, skipping up to `maxSkip` ordinary
   elements a Ghost editor session may have inserted between cards. */
function nextMatching(start, selector, maxSkip = 4) {
    let el = start?.nextElementSibling;
    let skipped = 0;
    while (el && skipped <= maxSkip) {
        if (el.matches(selector)) {
            return el;
        }
        skipped += 1;
        el = el.nextElementSibling;
    }
    return null;
}

/* Tag the art-directed sections with stable classes so the CSS never depends
   on card positions an ordinary Ghost edit can shift. */
function tagHomeSections() {
    const content = document.querySelector(".cs-content--home");
    if (!content) {
        return;
    }
    const headerCards = content.querySelectorAll(":scope > .kg-header-card");
    if (headerCards.length) {
        headerCards[0].classList.add("cs-hero");
        const last = headerCards[headerCards.length - 1];
        if (last !== headerCards[0]) {
            last.classList.add("cs-closing");
        }
    }
    const whoMarker = content.querySelector('[data-cs-section="who"]');
    const whoCard = whoMarker ? nextMatching(whoMarker, ".kg-product-card") : null;
    if (whoCard) {
        whoCard.classList.add("cs-who-card");
    }
}

/* Ghost owns the hero words as an ordinary H6 plus a Header card. The theme
   moves the H6 into the drawing and rebuilds the two visual paragraphs. This
   also repairs the legacy save-normalized form where Ghost merged the old
   classed spans into one white-space text run. */
function hydrateHomepageHero() {
    const hero = document.querySelector(".cs-home .kg-header-card.cs-hero");
    const heading = hero?.querySelector(".kg-header-card-heading");
    const subheading = hero?.querySelector(".kg-header-card-subheading");
    if (!hero || !heading || heading.dataset.csNativeReady === "true") {
        return;
    }

    const nativeKicker = hero.previousElementSibling?.matches("h6")
        ? hero.previousElementSibling
        : null;
    const legacyKicker = heading.querySelector(".cs-card-kicker");
    const legacyHeading = heading.querySelector(".cs-card-heading");
    // Native rich-text line breaks survive Ghost editor saves; CSS classes do not.
    const headingCopy = (legacyHeading || heading).cloneNode(true);
    headingCopy.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
    const authoredLines = headingCopy.textContent.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    const combinedHeading = authoredLines.join(" ").replace(/\s+/g, " ").trim();
    const kickerText = normalizedText(nativeKicker) || normalizedText(legacyKicker)
        || (combinedHeading.startsWith(homeCardLabels.hero) ? homeCardLabels.hero : "");
    const displayHeading = normalizedText(legacyHeading)
        || withoutLeadingLabel(combinedHeading, kickerText || homeCardLabels.hero);

    heading.textContent = displayHeading;
    heading.classList.add("cs-card-heading");
    heading.dataset.csNativeReady = "true";
    if (authoredLines.length > 1 && authoredLines.join(" ") === displayHeading) {
        heading.dataset.csHeadlineLines = JSON.stringify(authoredLines);
    }

    if (kickerText) {
        const kicker = nativeKicker || document.createElement("h6");
        kicker.textContent = kickerText;
        kicker.classList.add("cs-card-kicker");
        heading.before(kicker);
    }

    if (!subheading || subheading.dataset.csNativeReady === "true") {
        return;
    }

    const legacyParagraphs = [...subheading.querySelectorAll(".cs-card-paragraph")]
        .map((element) => normalizedText(element))
        .filter(Boolean);
    const subheadingCopy = subheading.cloneNode(true);
    subheadingCopy.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
    const rawSubheading = subheadingCopy.textContent.trim();
    let paragraphs = legacyParagraphs;

    if (paragraphs.length < 2) {
        paragraphs = rawSubheading.split(/\n\s*\n/).map((value) => value.trim()).filter(Boolean);
    }
    if (paragraphs.length < 2) {
        const breakAt = rawSubheading.indexOf(homeHeroSecondParagraphStart);
        paragraphs = breakAt > 0
            ? [rawSubheading.slice(0, breakAt).trim(), rawSubheading.slice(breakAt).trim()]
            : [rawSubheading];
    }

    subheading.textContent = "";
    paragraphs.forEach((value) => {
        const paragraph = document.createElement("span");
        paragraph.className = "cs-card-paragraph";
        paragraph.textContent = value;
        subheading.appendChild(paragraph);
    });
    subheading.dataset.csNativeReady = "true";
}

/* Respect Ghost-authored headline lines. Older headlines without breaks retain
   their original word-per-line presentation. The second line keeps the accent. */
function splitHeroHeading() {
    const heading = document.querySelector(".cs-home .kg-header-card.cs-hero .kg-header-card-heading.cs-card-heading");
    if (!heading || heading.dataset.csSplitReady === "true") {
        return;
    }

    const words = heading.dataset.csHeadlineLines
        ? JSON.parse(heading.dataset.csHeadlineLines)
        : heading.textContent.trim().split(/\s+/);
    heading.textContent = "";
    words.forEach((word, index) => {
        const line = document.createElement("span");
        line.textContent = index < words.length - 1 ? `${word} ` : word;
        heading.appendChild(line);
    });
    heading.dataset.csSplitReady = "true";
}

/* Product-card titles have one editor-supported job: the display heading. A
   first plain description paragraph carries the kicker and is moved above the
   title for presentation. The merged legacy form is recognized so deploying
   the resilient theme repairs the currently broken Page before its one-time
   content migration runs. */
function hydrateCardKicker(card, expectedLabel) {
    const titleContainer = card?.querySelector(".kg-product-card-title-container");
    const title = titleContainer?.querySelector(".kg-product-card-title");
    const description = card?.querySelector(".kg-product-card-description");
    if (!titleContainer || !title || title.dataset.csNativeReady === "true") {
        return;
    }

    const legacyKicker = title.querySelector(".cs-card-kicker");
    const legacyHeading = title.querySelector(".cs-card-heading");
    const firstParagraph = description?.querySelector(":scope > p:first-child");
    const firstIsKicker = normalizedText(firstParagraph).replaceAll("’", "'") === expectedLabel;
    const combinedTitle = normalizedText(title);
    const titleHasMergedKicker = combinedTitle.startsWith(expectedLabel);
    const kickerText = normalizedText(legacyKicker)
        || (firstIsKicker ? normalizedText(firstParagraph) : "")
        || (titleHasMergedKicker ? expectedLabel : "");
    const displayHeading = normalizedText(legacyHeading)
        || withoutLeadingLabel(combinedTitle, kickerText || expectedLabel);

    title.textContent = displayHeading;
    title.classList.add("cs-card-heading");
    title.dataset.csNativeReady = "true";

    if (kickerText) {
        const kicker = firstIsKicker ? firstParagraph : document.createElement("p");
        kicker.textContent = kickerText;
        kicker.classList.add("cs-card-kicker");
        titleContainer.insertBefore(kicker, title);
    }
}

function hydrateHomepageCardTitles() {
    const who = document.querySelector(".cs-home .kg-product-card.cs-who-card");
    hydrateCardKicker(who, homeCardLabels.who);

    const mediaCards = document.querySelectorAll(".cs-home .cs-card-grid--media .kg-product-card");
    hydrateCardKicker(mediaCards[0], homeCardLabels.writing);
    hydrateCardKicker(mediaCards[1], homeCardLabels.podcast);
}

/* Move a product card's first description paragraph up beside its title so the
   ink offer-card header band reads title-then-audience, as designed. */
function liftLeadParagraph(card) {
    const titleContainer = card.querySelector(".kg-product-card-title-container");
    const description = card.querySelector(".kg-product-card-description");
    const lead = description?.querySelector("p:first-child");

    if (!titleContainer || !lead || titleContainer.querySelector(".cs-offer-lead")) {
        return;
    }

    lead.classList.add("cs-offer-lead");
    titleContainer.appendChild(lead);
}

/* Wrap the workshop grid, the Custom Workshops card, and the section CTA in one
   region so the decorative x-mark rail can sit beside them, and make each
   off-the-shelf offer card link to its door on Work With Me (matching live v3). */
function buildOfferRegion() {
    const grid = document.querySelector(".cs-home .cs-card-grid--offers");
    if (!grid || grid.closest(".cs-offer-region")) {
        return;
    }

    const region = document.createElement("div");
    region.className = "cs-offer-region";
    grid.before(region);

    const custom = nextMatching(region, ".kg-product-card");
    const cta = nextMatching(custom || region, ".kg-button-card");

    region.appendChild(grid);
    if (custom) {
        custom.classList.add("cs-custom-offer");
        region.appendChild(custom);
    }
    if (cta) {
        const customContainer = custom?.querySelector('.kg-product-card-container');
        if (customContainer) {
            cta.classList.add('cs-custom-offer-action');
            customContainer.appendChild(cta);
        } else {
            region.appendChild(cta);
        }
    }

    const doors = ["/work-with-me/#door-one", "/work-with-me/#door-two"];
    grid.querySelectorAll(".kg-product-card").forEach((card, index) => {
        liftLeadParagraph(card);
        if (doors[index] && !card.querySelector("a")) {
            const link = document.createElement("a");
            link.className = "cs-offer-link";
            link.href = doors[index];
            const container = card.querySelector(".kg-product-card-container");
            if (container) {
                card.appendChild(link);
                link.appendChild(container);
            }
        }
    });

    if (custom?.querySelectorAll(".kg-product-card-description > p").length > 1) {
        liftLeadParagraph(custom);
    }
}

/* Stage the Who's Asking portrait: the ink and rust shapes plus the one-off
   rust loop arrow are theme-owned geometry; the photograph stays a Ghost image. */
function buildWhoStage() {
    const card = document.querySelector('.cs-home .kg-product-card.cs-who-card');
    const image = card?.querySelector(".kg-product-card-image");
    if (!card || !image || card.querySelector(".cs-who-stage")) {
        return;
    }

    const stage = document.createElement("div");
    stage.className = "cs-who-stage";
    image.before(stage);
    stage.appendChild(image);

    stage.insertAdjacentHTML(
        "beforeend",
        '<svg class="cs-who-arrow" viewBox="0 0 150 112" aria-hidden="true" focusable="false">' +
            '<path d="M12 10C27 58 58 85 126 84" />' +
            '<path d="M126 84L106 67M126 84L104 98" />' +
        "</svg>"
    );
}

/* Stage the Read/Listen cut-outs on their ink panels with the rust blob. */
function buildMediaStages() {
    document.querySelectorAll(".cs-home .cs-card-grid--media .kg-product-card").forEach((card) => {
        const image = card.querySelector(".kg-product-card-image");
        if (!image || card.querySelector(".cs-media-stage")) {
            return;
        }
        const stage = document.createElement("div");
        stage.className = "cs-media-stage";
        image.before(stage);
        stage.appendChild(image);
    });
}

/* Rebuild the newsletter banner: one SVG drawing carries the arched label and
   the paper dome so they can never drift apart (the v3 hard-won rule). The
   label comes from an adjacent editor-native H6, with a theme-owned fallback
   for legacy Pages; the geometry remains theme-owned. */
function buildNewsletterSection() {
    const signup = document.querySelector(".cs-home .kg-signup-card");
    if (!signup || signup.closest(".cs-newsletter")) {
        return;
    }

    const nativeKicker = signup.previousElementSibling?.matches("h6")
        ? signup.previousElementSibling
        : null;
    const heading = signup.querySelector(".kg-signup-card-heading");
    const legacyKicker = heading?.querySelector(".cs-card-kicker");
    const legacyHeading = heading?.querySelector(".cs-card-heading");
    const combinedHeading = normalizedText(heading);
    const label = normalizedText(nativeKicker) || normalizedText(legacyKicker)
        || homeCardLabels.newsletter;
    const displayHeading = normalizedText(legacyHeading)
        || withoutLeadingLabel(combinedHeading, homeCardLabels.newsletter);

    const section = document.createElement("section");
    section.className = "cs-newsletter";
    signup.before(section);

    const accessibleLabel = nativeKicker || document.createElement("h6");
    accessibleLabel.textContent = label;
    accessibleLabel.classList.add("cs-newsletter-source-label", "sr-only");
    section.appendChild(accessibleLabel);

    if (heading) {
        heading.textContent = displayHeading;
        heading.classList.add("cs-card-heading");
    }

    const svgNS = "http://www.w3.org/2000/svg";
    const banner = document.createElementNS(svgNS, "svg");
    banner.setAttribute("class", "cs-newsletter-banner");
    banner.setAttribute("viewBox", "0 0 1000 320");
    banner.setAttribute("aria-hidden", "true");
    banner.setAttribute("focusable", "false");

    const defs = document.createElementNS(svgNS, "defs");
    const arc = document.createElementNS(svgNS, "path");
    arc.setAttribute("id", "cs-newsletter-title-arc");
    arc.setAttribute("d", "M-142.9 274A1341 1341 0 0 1 1142.9 274");
    defs.appendChild(arc);
    banner.appendChild(defs);

    const dome = document.createElementNS(svgNS, "path");
    dome.setAttribute("class", "cs-newsletter-dome");
    dome.setAttribute("d", "M0 318.7A500 171.5 0 0 1 1000 318.7L1000 320L0 320Z");
    banner.appendChild(dome);

    if (label) {
        const text = document.createElementNS(svgNS, "text");
        const textPath = document.createElementNS(svgNS, "textPath");
        textPath.setAttribute("href", "#cs-newsletter-title-arc");
        textPath.setAttribute("startOffset", "50%");
        textPath.setAttribute("text-anchor", "middle");
        textPath.textContent = label;
        text.appendChild(textPath);
        banner.appendChild(text);
    }

    section.appendChild(banner);
    section.appendChild(signup);

    if (heading && heading.dataset.csNewsletterSplit !== "true") {
        const value = heading.textContent.trim();
        const breakAt = value.indexOf(",");
        if (breakAt > -1 && breakAt < value.length - 1) {
            const first = document.createElement("span");
            const second = document.createElement("span");
            first.textContent = `${value.slice(0, breakAt + 1).trim()} `;
            second.textContent = value.slice(breakAt + 1).trim();
            heading.textContent = "";
            heading.append(first, second);
        }
        heading.dataset.csNewsletterSplit = "true";
    }

    const input = signup.querySelector("input[data-members-email]");
    if (input) {
        input.setAttribute("placeholder", "Your Email Address");
    }
}

/* --- Inner pages: editor-safe kickers ----------------------------------

   Ghost re-serializes every card rich-text field on save and drops class
   attributes, so a kicker stored as <span class="cs-card-kicker"> inside a
   card heading does not survive the editor. On 2026-09-01 a single save on
   the Writing page merged its two spans and then lost the word "Read"
   outright. Inner pages therefore store kickers in ordinary nodes Ghost
   preserves, the same way the homepage already does:

     Header / Signup cards  an <h6> immediately before the card
     Product cards          the first paragraph of the card description,
                            where a [data-cs-kicker="first-p"] marker says so

   The legacy span form still renders, so a page is correct both before and
   after its content migration. Card runs are read until the first element
   that is not part of the run rather than by a fixed count. */

function liftHeaderKicker(card, kicker) {
    const text = card.querySelector(".kg-header-card-text, .kg-signup-card-text");

    if (!text || card.dataset.csKickerReady === "true") {
        return;
    }

    const heading = card.querySelector(".kg-header-card-heading, .kg-signup-card-heading");

    /* Ghost omits the heading element entirely when the card's header field is
       empty, which is the case wherever the copy carries a kicker and body but
       no separate display line. Fall back to the subheading, then to whatever
       the card leads with, so the kicker still lands inside the field. */
    const anchor = heading
        || card.querySelector(".kg-header-card-subheading, .kg-signup-card-subheading")
        || text.firstElementChild;

    kicker.classList.add("cs-card-kicker");

    if (anchor) {
        text.insertBefore(kicker, anchor);
    } else {
        text.appendChild(kicker);
    }

    if (heading) {
        heading.classList.add("cs-card-heading");
    }

    card.dataset.csKickerReady = "true";
}

function hydrateInnerPageHeaderKickers() {
    document.querySelectorAll(".cs-page .cs-content > h6").forEach((kicker) => {
        const card = kicker.nextElementSibling;
        if (card && card.matches(".kg-header-card, .kg-signup-card")) {
            liftHeaderKicker(card, kicker);
        }
    });
}

function adjacentProductCards(marker) {
    const cards = [];
    let element = marker.nextElementSibling;

    while (element && element.matches(".kg-product-card, [data-cs-layout], [data-cs-kicker]")) {
        if (element.matches(".kg-product-card")) {
            cards.push(element);
        }
        element = element.nextElementSibling;
    }

    return cards;
}

function liftDescriptionKicker(card) {
    const titleContainer = card.querySelector(".kg-product-card-title-container");
    const title = titleContainer?.querySelector(".kg-product-card-title");
    const description = card.querySelector(".kg-product-card-description");
    const first = description?.querySelector(":scope > p:first-child");

    if (!titleContainer || !title || !first || title.dataset.csKickerReady === "true") {
        return;
    }

    first.classList.add("cs-card-kicker");
    titleContainer.insertBefore(first, title);
    title.classList.add("cs-card-heading");
    title.dataset.csKickerReady = "true";
}

function hydrateInnerPageCardKickers() {
    document.querySelectorAll('.cs-page [data-cs-kicker="first-p"]').forEach((marker) => {
        adjacentProductCards(marker).forEach(liftDescriptionKicker);

        /* A grid marker is still needed by groupEditorialCards; a bare
           kicker marker has done its job. */
        if (!marker.hasAttribute("data-cs-layout")) {
            marker.remove();
        }
    });
}

function normalizeDecorativeCardImages() {
    document.querySelectorAll(".kg-product-card-image:not([alt])").forEach((image) => {
        image.setAttribute("alt", "");
    });
}

function normalizeSignupInputs() {
    document.querySelectorAll("input[data-members-email]").forEach((input) => {
        const hasLabel = input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!hasLabel && !input.hasAttribute("aria-label") && !input.hasAttribute("aria-labelledby")) {
            input.setAttribute("aria-label", "Email address");
        }
    });
}

/* Keep the Writing introduction in one visual field without changing its
   ordinary, editor-owned paragraph nodes or the archive that follows it. */
function groupWritingIntroduction() {
    const content = document.querySelector('.cs-page--writing > .cs-content');
    const header = content?.querySelector(':scope > .kg-header-card');
    const text = header?.querySelector('.kg-header-card-text');
    if (!header || !text || header.dataset.csIntroReady === 'true') return;
    let paragraph = header.nextElementSibling;
    while (paragraph?.matches('p')) {
        const next = paragraph.nextElementSibling;
        paragraph.classList.add('cs-writing-intro-paragraph');
        text.appendChild(paragraph);
        paragraph = next;
    }
    header.dataset.csIntroReady = 'true';
    content.querySelectorAll('.kg-signup-card .cs-card-kicker').forEach(kicker => kicker.classList.add('sr-only'));
}

/* The two summary cards duplicated the complete workshops immediately below.
   Hide only a verified duplicate run; all native copy remains editable. */
function removeDuplicateWorkshopSummaries() {
    const content = document.querySelector('.cs-content--landing');
    if (!content?.querySelector('#door-one') || !content.querySelector('#door-two') || !content.querySelector('.hs-form-frame')) return;
    content.closest('article')?.classList.add('cs-page--workshops');
    const titles = new Set([...content.querySelectorAll(':scope > h2')].map(e => normalizedText(e).toLowerCase()));
    content.querySelectorAll(':scope > .cs-card-grid--offers').forEach(grid => {
        const cards = [...grid.querySelectorAll('.kg-product-card-title')];
        if (cards.length && cards.every(title => titles.has(normalizedText(title).toLowerCase()))) {
            grid.hidden = true;
            grid.classList.add('cs-workshop-duplicates');
        }
    });
}

/* The existing stool image has transparent margins (390,386)-(1554,1167).
   Its frame follows the owner's larger, intentionally cropped reference.
   Other owner-selected images keep their ordinary uncropped presentation. */
function frameClosingArtwork() {
    const image = document.querySelector('.cs-closing .kg-header-card-image');
    if (image?.getAttribute('src')?.split('?')[0].endsWith('/stools.png')) {
        image.closest('picture')?.classList.add('cs-stool-frame');
    }
}

function normalizeToggleIcons() {
    document.querySelectorAll(".kg-toggle-card-icon svg[id]").forEach((icon) => {
        icon.removeAttribute("id");
    });
}

/* Group existing editor nodes; no workshop copy or form markup is generated. */
function arrangeWorkshopSections() {
    const content = document.querySelector('.cs-page--workshops > .cs-content');
    if (!content || content.querySelector('.cs-workshop-section')) return;
    const jumps = [];
    for (const id of ['door-one', 'door-two']) {
        const marker = content.querySelector(`:scope > #${id}`);
        if (!marker) continue;
        const nodes = [];
        let node = marker.nextElementSibling;
        while (node && !node.id.startsWith('door-')) {
            nodes.push(node);
            if (node.matches('.kg-button-card')) break;
            node = node.nextElementSibling;
        }
        const heading = nodes.find(e => e.matches('h2'));
        const callout = nodes.find(e => e.matches('.kg-callout-card'));
        const button = nodes[nodes.length - 1];
        if (!heading || !callout || !button?.matches('.kg-button-card')) continue;
        const section = document.createElement('section');
        section.className = 'cs-workshop-section';
        section.id = id;
        section.setAttribute('aria-labelledby', heading.id);
        const body = document.createElement('div');
        body.className = 'cs-workshop-body';
        const details = document.createElement('div');
        details.className = 'cs-workshop-details';
        marker.replaceWith(section);
        nodes.forEach(e => (e === callout || e === button ? details : body).appendChild(e));
        section.append(body, details);
        jumps.push([id, normalizedText(heading)]);
    }
    const contact = content.querySelector('#contact');
    const contactHeading = contact?.nextElementSibling;
    if (contactHeading?.matches('h2')) jumps.push(['contact', normalizedText(contactHeading)]);
    const heroText = content.querySelector(':scope > .kg-header-card .kg-header-card-text');
    if (heroText && jumps.length) {
        const nav = document.createElement('nav');
        nav.className = 'cs-workshop-jumps';
        nav.setAttribute('aria-label', 'Workshops and contact');
        jumps.forEach(([id, label]) => {
            const link = document.createElement('a');
            link.href = `#${id}`;
            link.textContent = label;
            nav.appendChild(link);
        });
        heroText.appendChild(nav);
    }
}

function safely(step) {
    try {
        step();
    } catch (error) {
        /* One unexpected structure must degrade only its own section, never
           the rest of the page. */
        console.warn("cross-street hydration step failed:", error);
    }
}

export default function hydrateDynamicSlots() {
    safely(hydrateHeroSecondaryAction);
    if (document.querySelector(".cs-page")) {
        /* Kickers are lifted before grouping so a layout marker can declare
           the mode for the run of cards that follows it. */
        safely(hydrateInnerPageCardKickers);
        safely(hydrateInnerPageHeaderKickers);
    }
    safely(groupEditorialCards);
    safely(groupWritingIntroduction);
    safely(removeDuplicateWorkshopSummaries);
    safely(arrangeWorkshopSections);
    if (document.querySelector(".cs-home")) {
        safely(tagHomeSections);
        safely(hydrateHomepageHero);
        safely(splitHeroHeading);
        safely(buildOfferRegion);
        safely(hydrateHomepageCardTitles);
        safely(buildWhoStage);
        safely(buildMediaStages);
        safely(buildNewsletterSection);
        safely(frameClosingArtwork);
    }
    safely(hydrateLatestWriting);
    safely(normalizeDecorativeCardImages);
    safely(normalizeSignupInputs);
    safely(normalizeToggleIcons);
}
